import React from "react";
import moment from "moment";
import SvgIcon from "../svg-icon";


const NotificationStaticItem = (props) => {

    const {title, description, timestamp} = props.notification
    // todo [ti-circle-check,ti-circle-x,ti-info-circle,ti-info-gift]


    return (
        <li>
            <a onClick={null} className="green tip">
                <div className="d-flex align-items-center justify-content-center gap-2">
                    <SvgIcon id={'ti-info-circle'}/>
                    <div className="d-flex flex-column fit-content">
                        <span className="title">
                            {title}
                        </span>
                        <span className="mt-2">
                            {description}
                        </span>
                    </div>

                </div>
                <span className="date">{moment.unix(timestamp).format('MMM Do YY')}</span>
            </a>
        </li>
    )
}

export default NotificationStaticItem
